import Forms from "../../../../app/Components/Forms/Forms";

const ChangePassword = {

    strengthScoreValues: {
        1: {class: 'very-weak', text: 'Veľmi slabé'},
        2: {class: 'weak', text: 'Slabé'},
        3: {class: 'medium', text: 'Stredné'},
        4: {class: 'strong', text: 'Silné'}
    },

    init() {

        this.el = $('[component="ChangePassword"]');

        if (!this.el.length) {
            return;
        }

        this.form = this.el.find("form");
        this.newPasswordInput = this.el.find("#new-password");
        this.strengthIndicator = this.newPasswordInput.parents('[component]').find(".strength-indicator");
        this.submitButton = this.el.find('button[type="submit"]');

        Forms.init(this.form);
        Forms.focusFirstInput(this.form);
        Forms.setButtonPulseAfterEdit();
        Forms.setFormSubmitButton(this.submitButton);

        this.bind();
    },

    bind() {
        this.form.submit((event) => {
            Forms.setSendData(Forms.inputData(ChangePassword.form));
        });

        this.newPasswordInput.on("keyup", function (element) {

            if (!ChangePassword.strengthIndicator.length) {
                return;
            }

            let password = $(this).val();
            let minLength = $(this).attr("minlength");

            let strength = ChangePassword.getScore(password, minLength);

            ChangePassword.setPasswordStrength(strength);
        });
    },


    getScore(password, minLength, strength = 0) {
        if (password.length >= minLength) {
            strength += 1;
        }
        if (password.match(/[a-z]+/) || password.match(/[A-Z]+/)) {
            strength += 1;
        }
        if (password.match(/[0-9]+/)) {
            strength += 1;
        }
        if (password.match(/[^A-Za-z0-9]/)) {
            strength += 1;
        }

        return strength;
    },

    setPasswordStrength(strength) {
        let strengthValues = ChangePassword.strengthScoreValues[strength];

        $(ChangePassword.strengthIndicator)
            .attr("class", "strength-indicator")
            .addClass(strengthValues.class);

        $(ChangePassword.strengthIndicator).find(".text").text(strengthValues.text);
    }
}
export default ChangePassword;